import React from 'react';

const SpeakerSelect = ({ 
  speakerData,
  setSelectedSpeaker,
  selectedSpeaker,
  sendTextToAPI, // ✅ Added
  textContent,    // ✅ Added
  audioRef       // ✅ Added
}) => {
  const handleSpeakerChange = (e) => {
    const newSpeaker = e.target.value;

    // ✅ Only proceed if the speaker is actually different
    if (newSpeaker !== selectedSpeaker) {
        setSelectedSpeaker(newSpeaker);
        sendTextToAPI(textContent, newSpeaker, true, true); // ✅ Request new audio
    } else {
        console.log("📌 Speaker is unchanged. Playing existing audio...");
        if (audioRef.current && audioRef.current.audio) {
            audioRef.current.audio.currentTime = 0;
            audioRef.current.audio.play()
                .then(() => console.log("▶️ Playing existing audio"))
                .catch(error => console.error("Playback error:", error));
        }
    }
};

  return (
    <div className="speaker-section">
      <h2 className="speaker-heading">Select a WellSaid Voice</h2>
      <div className="speaker-dropdown-container">
        <select
          id="speaker-select"
          className="speaker-dropdown"
          value={selectedSpeaker}
          onChange={handleSpeakerChange}
        >
          {speakerData.map((speaker, index) => (
            <option key={speaker.id} value={speaker.id}>
              {index + 1}. {speaker.name} - {speaker.style} ({speaker.accent_type})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SpeakerSelect;
